<template>
    <CompassDatePicker
        :modelValue="activityDateFormated"
        :input="false"
        :formatDateDisplayed="formatDateDisplayed"
        :placement="placement"
        :calendarOptions="calendarOptions"
        datePickerClass="activities-reschedule-datepicker"
        @update:modelValue="handleUpdateModelValue"
    >
        <slot></slot>
    </CompassDatePicker>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { difference } from 'lodash';

const { mapState: corpMapState } = createNamespacedHelpers('corp');
const { mapGetters: activitiesMapGetters } = createNamespacedHelpers('activitiesStores');
export default {
    props: {
        //Accept date in string format or directly moment object
        modelValue: {
            type: [String, Object],
            required: true,
        },
        placement: {
            type: String,
            default: 'top-start',
        },
    },
    computed: {
        ...corpMapState(['uiLang', 'timeformat']),
        ...activitiesMapGetters({ metas: 'getMetas' }),
        formatDateDisplayed() {
            return this.timeformat === 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
        },
        activityDateFormated() {
            return moment(this.modelValue).format('YYYY-MM-DD');
        },
        disableWeekDays() {
            return difference([0, 1, 2, 3, 4, 5, 6], this.metas.working_days);
        },
        calendarOptions() {
            return {
                lang: this.uiLang,
                disableWeekDays: this.disableWeekDays,
            };
        },
    },
    methods: {
        handleUpdateModelValue(modelValue) {
            const oldDateMoment = moment(this.modelValue);
            const newDateMoment = moment(modelValue);
            if (oldDateMoment.isSame(newDateMoment, 'day')) {
                return;
            }
            this.$emit('update:modelValue', modelValue);
        },
    },
};
</script>

<style lang="scss">
#compass-date-picker-container {
    .activities-reschedule-datepicker {
        z-index: 1000;
    }
}
</style>
